import React, { useState, useEffect } from 'react';
import style from '../../css/cards/News.module.css';

const News = ({ title, page, image, imageMobile, description }) => {
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	return (
		<div className={style.mainContainer}>
			<div className={style.imageContainer}>
				<img src={windowWidth > 700 ? image : imageMobile} alt='new' />
			</div>

			<div className={style.content}>
				<h1>{title}</h1>
				<a href={page}>Mayor información</a>
			</div>
		</div>
	);
};

export default News;
